/* eslint-disable no-unused-vars */
import { useRef, useEffect, useContext } from 'react';
import * as S from './DropDownList.styled';
import { ManageCampaignsContext } from 'contexts';
import { useSignal } from '@preact/signals-react';
import { CampaignItem } from './CampaignItem';
import { AppItem } from './AppItem';

export const DropDownList = ({
  showDropDown$,
  filteredCampaignsAndApps$,
  searchRef,
  searchValue$,
}) => {
  const dropDownListRef = useRef();
  const { isActiveCamp, toggleCamp, toggleApp, isActiveApp, handleClickOutsideDropDown } =
    useContext(ManageCampaignsContext);

  const heightOfList$ = useSignal(400);

  const handleClickOutside = (event) => {
    if (dropDownListRef.current && dropDownListRef.current.contains(event.target)) {
      document.addEventListener('click', handleClickOutside, { capture: true, once: true });
      return;
    }
    if (searchRef.current && searchRef.current.contains(event.target)) {
      document.addEventListener('click', handleClickOutside, { capture: true, once: true });
      return;
    }
    if (
      showDropDown$.value &&
      dropDownListRef.current &&
      !dropDownListRef.current.contains(event.target)
    ) {
      console.log('click outside after selecting');
      searchValue$.value = '';
      showDropDown$.value = false;
      //handleClickOutsideDropDown(showDropDown$);
    }
  };

  const onScroll = (event) => {
    showDropDown$.value = false;
  };

  useEffect(() => {
    if (showDropDown$.value) {
      document.addEventListener('click', handleClickOutside, { capture: true, once: true });
      window.addEventListener('scroll', onScroll, { once: true });
    }

    return () => {
      document.removeEventListener('click', handleClickOutside, { capture: true, once: true });
      window.removeEventListener('scroll', onScroll, { once: true });
    };
  }, [showDropDown$.value]);

  const handleClickOnItem = (campaignOrAppData) => {
    if (campaignOrAppData.isApp) {
      toggleApp(...campaignOrAppData.containedIn);
    } else {
      toggleCamp(campaignOrAppData._campaignid);
    }
    handleClickOutsideDropDown(showDropDown$);
  };

  if (!filteredCampaignsAndApps$.value) return null;
  if (
    !filteredCampaignsAndApps$.value.campaigns.length &&
    !filteredCampaignsAndApps$.value.applications.length
  )
    return (
      <S.NoResultContainer ref={dropDownListRef} isOpen={showDropDown$.value}>
        No matches found
      </S.NoResultContainer>
    );

  return (
    <S.Container ref={dropDownListRef} isOpen={showDropDown$.value} className='dropdown_base'>
      <S.MyVirtuoso
        height={heightOfList$.value}
        totalListHeightChanged={(height) => (heightOfList$.value = height)}
        fixedItemHeight={56}
        data={filteredCampaignsAndApps$.value.applications.concat(
          filteredCampaignsAndApps$.value.campaigns,
        )}
        itemContent={(index, rowData) => {
          if (!rowData.isApp) {
            return (
              <>
                {!rowData.index && <S.Title>Campaigns:</S.Title>}
                <CampaignItem
                  rowData={rowData}
                  handleClickOnItem={handleClickOnItem}
                  isActiveCamp={isActiveCamp}
                  searchValue$={searchValue$}
                />
              </>
            );
          }

          if (rowData.isApp) {
            return (
              <>
                {!rowData.index && <S.Title>Applications:</S.Title>}
                <AppItem
                  rowData={rowData}
                  handleClickOnItem={handleClickOnItem}
                  isActiveApp={isActiveApp}
                  searchValue$={searchValue$}
                />
              </>
            );
          }
        }}
      />
    </S.Container>
  );
};
